import { Component, OnInit } from '@angular/core';
import { ApiService } from '../service/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit {

  batches:any=[];
  users:any=[];
  interval: any;
  pendingAmount=0;
  constructor(private api:ApiService,private route:ActivatedRoute) { }

  ngOnInit() {
    this.route.data.subscribe(data=>{
      let user=data.users[0].users;
      if(data.users[0].status)
      {
        this.batches=data.users[0].batches;
        this.batches.forEach((e,index) => {
          if(user)
          {
            let auser=user.filter((v)=>{return v.batch_detail_id==e.batch_detail_id});
            this.users.push(auser);
          }

        });
      }
      if(this.interval){
        clearInterval(this.interval);
      }
      this.interval = setInterval(() => {
          this.refreshData();
      }, 4000);



    },(error)=>{

    });
  }

  refreshData()
  {
    this.api.get('userDashboard').subscribe(data=>{
      this.batches=[];
      this.users=[];
      let user=data.users;
      if(data.status)
      {
        this.batches=data.batches;
        this.batches.forEach((e,index) => {
          if(user)
          {
            let auser=user.filter((v)=>{return v.batch_detail_id==e.batch_detail_id});
            this.users.push(auser);
          }

        });
      }
    },(error)=>{});
  }

}
